<template>
	<div class="edit-profilebox add-new-memberbox savingaccount-formbox">
		<ul class="breadcrumbs-list">
		  <a  @click="backButton"><li>Value Added Services</li></a>
		  <a  @click="backButton"><li>&nbsp;>&nbsp;Goal Sure</li></a>
		  <a  @click="backButton"><li>&nbsp;>&nbsp;Edu Meter</li></a>
		  <li>&nbsp;>&nbsp;Edu Meter Form</li>
		</ul>
	    <h4><v-img  max-width="170" :src=" edumeterLogo" :lazy-src="edumeterLogo"> </v-img></h4>
		<div class="edit-profilebox-detail">
			<v-form ref="form" id="saving_account" @submit.prevent class="login-form-box register-page" lazy-validation>
			    <h4>Check your life & health insurance gap</h4>
			    <v-row>
					<v-col xs="4" md="3" class="member_relation_box col">
						<label class="member-label">Member </label>
						<v-select
			                v-model="mainMember"
			                :items="allMemberList"
			                item-value="id"
			                item-text="name"
			                :value="mainMember"
			                placeholder="Select"
			                @change="setMainMemberData($event)"
			                max-width="500px"
			                
                            :rules="[v => !!v || 'Field is required']"
			            ></v-select>	
					</v-col>
					<v-col xs="4" md="3" class="member_relation_box col">
						<label class="member-label">DOB </label>
						<div class="dob-box">
							<Datepicker
			                    name="mainMemberDob" 
			                    ref="mainMemberDob"
			                    :v-model="mainMemberDob"
			                    format="dd MMM, yyyy"
			                    placeholdeerr="Select"
			                    :disabledDates="disabledDates"
			                    :value="mainMemberDob"
			                ></Datepicker>
			            </div>     
					</v-col>
					<v-col xs="4" md="3" class="member_relation_box col">
						<label class="member-label">Age </label>
						<v-text-field placeholder="Age" :v-model="mainMemberAge" :value="mainMemberAge">
						</v-text-field>	
					</v-col>
			    </v-row>
			    <v-row class="buttonbox">
			    	<span style="color:#1A407D; font-size:20px !important;"><b>Your Family Details</b></span>
			    </v-row>
			    <v-row v-for="(moreMemberItem, index) in moreMemberItmes">
					<v-col xs="4" md="3" class="member_relation_box col">
						<label class="member-label">Member</label>
						<v-combobox
						    :return-object="false"
			                v-model="moreMemberName[index]"
			                :items="updatedMemberList[index]"
			                item-value="name"
			                item-text="name"
			                placeholder="Select Or Type Member"
			                @change="changeTextFieldEvent($event), updateMoreMemberList($event, index)"
			                max-width="500px"
                            
			            ></v-combobox>
					</v-col>
					<v-col xs="4" md="3" class="member_relation_box col">
						<label class="member-label">Relation</label>
						<v-select
			                v-model="moreMemberType[index]"
			                :items="member_type_items"
			                item-value="id"
			                item-text="type"
			                placeholder="Select"			               
			                max-width="500px"
                            
			            ></v-select>
					</v-col>
					<v-col xs="4" md="3" class="member_relation_box col member_dob">
						<label class="member-label">DOB </label>
						<div class="dob-box1">
							<Datepicker
			                    v-model="moreMemberDob[index]"
			                    format="dd MMM, yyyy"
			                    placeholder="Select"
			                    :disabledDates="disabledDates"
			                    
			                    @selected="calculateMoreMemberAge($event, index)"
			                    value=""
			                ></Datepicker>
			            </div>     
					</v-col>
					<v-col xs="4" md="2" class="member_relation_box col">
						<label class="member-label">age </label>
						<v-text-field placeholder="Age" v-model="moreMemberAge[index]"  disabled>
						</v-text-field>	
					</v-col>
			    </v-row>
			    <div class="row">
			    	<v-col xs="12" md="10" class="member_relation_box col">
		                <div class="button-group" style="float:right">
		                  <button class="btn save-btn more_btn_class"  @click="addRow()">+ MORE</button>
		                  <button class="btn save-btn remove_btn_class"  @click="removeRow()" v-if="moreMemberItemCount >= 2">- Remove</button>
		                </div>
		            </v-col>    
	            </div>
	            <div class="row">
	            	<h4></h4>
	            	<div class="income_container">
	            		<!-- <div class="sync_detils main-sync-heading">
				            <span>Sync details</span>
				            <a @click="syncMemberData()"><v-img max-height="22" max-width="20" :src="syncIcon" ></v-img></a>
				        </div> -->
					    <section class="your_income_section">
					        <div class="col-md-6">
						        <div class="info_box">
						            <div class="income_title">
						              <h3>Your income & Expenses</h3>
						            </div>
						            <div class="income_date">
						              <p>Monthly</p>
						            </div>
						        </div>
					            <div class="your_ins_price expenses">
						            <div class="text_icon">
						            	<div><p>Your income</p></div>
						            	<div ><v-img max-height="15" max-width="15" :src="informationIcon" class="icon_tick" title="Please mention your Post Tax Take Home Amount including Rentals & Other Income"></v-img></div>
						            </div>
						            <div class="fields">
						                <v-text-field placeholder="₹ 0.00" v-model="monthlyIncome"></v-text-field>
						            </div>
					            </div>
								<div v-for="(memberTypeItem, index) in moreMemberType">
									<div class="your_ins_price" v-if="(memberTypeItem==2 || memberTypeItem==5)">
										<div class="d-flex">
										   <p>Education Expense for  {{moreMemberName[index]}}</p>
										   <div><v-img max-height="15" max-width="15" :src="informationIcon" class="icon_tick" title="Education expense will include school & college fees, tuition fees, fees for extra curricular activities etc. Please provide monthly expense"></v-img></div>
										</div>
										<div class="fields">
							                <v-text-field placeholder="₹ 0.00" v-model="otherChildrenExpense[index]" @change="setExpense(index, $event, 'manual')"></v-text-field>
										</div>
									</div>
								</div>	
					        </div>
					        <div class="col-md-6 investments">
								<div class="info_box">
									<div class="income_title">
									  <h3></h3>
									</div>
									<div class="income_date">
									  <p>Monthly</p>
									</div>
								</div>
								<div class="your_ins_price">
									<div class="d-flex">
									  <p>Current corpus/savings twords education expense</p>
									  
									</div>
									<div class="fields">
									  <v-text-field placeholder="₹ 0.00" v-model="currentCorpusSavingsTwordsEducationExpense"></v-text-field>
									</div>
								</div>
					        </div>
					    </section>
				    </div>
					<v-dialog v-model="edumeter_score_dialog" width="900">
						<v-card class="secure-modal proceed-modal csv-file-modal riskmeter_main">
							<v-card-title class="text-h5" >Your&nbsp;<b>EDU</b><sub>METER</sub>&nbsp;Score card is shown below.</v-card-title>
							<v-card-text>
								<div class="row">
									<h4></h4>
					            	<div class="income_container">
					            		<div class="sync_detils">
								        </div>
									    <section class="your_income_section">
									        <div class="col-md-8">
										        <div class="info_box date-and-info">
										            <div class="income_title">
										              
										            </div>
										            <div class="income_date d-flex">
										              <h3>Last Updated: {{lastModifiedDate}}</h3>
										            </div>
										            <!-- <div class="income_date d-flex">
										              <p>Update/modify</p>
								                      <v-img max-height="22" max-width="20" :src="syncIcon" ></v-img>
										            </div> -->
										        </div>
									            <div class="your_ins_price expenses">
										            <div class="text_icon">
										            	<div><p>Current Monthly Saving To Meet Educational Expenses</p></div>
										            </div>
										            <div class="fields">
										              <input type="text" name="" id="" placeholder="₹ 0.00" :value="formatPrice(current_monthly_saving_to_meet_educational_expenses)" readonly />
										            </div>
									            </div>
									            <div class="your_ins_price expenses">
										            <div class="text_icon">
										            	<div><p>Additional Monthly Saving To Meet Educational Expenses</p></div>
										            </div>
										            <div class="fields">
										              <input type="text" name="" id="" placeholder="₹ 0.00" :value="formatPrice(additional_monthly_saving_needed)" readonly/>
										            </div>
									            </div>
									            <div class="your_ins_price expenses">
										            <div class="text_icon">
										            	<div><p>Your &nbsp;<b>EDU</b><sub>METER</sub>&nbsp;Score</p></div>
										            </div>
										            <div class="fields">
										              <input type="text" name="" id="" placeholder="₹ 0.00" :value="edumeterScore" readonly/>
										            </div>
									            </div>
									            <div class="terms-box">
										        	<p>{{message}}</p>
										        </div>
									        </div>
									    </section>
								    </div>
								</div>
					            <div class="riskMeter_btn" style="margin-left:20px"><br>
						            <v-btn type="submit" style="color: #051d42 !important; border-color: 1px solid #051d42 !important; height: 46px !important;font-family: Work Sans, sans-serif;min-width: 200px !important;margin-right:12px" @click="proceed('investometer')"  
						              >INVESTOMETER</v-btn>
						            <v-btn type="submit" style="background-color: #051d42 !important;color: #fff !important;height: 46px !important;font-family: Work Sans, sans-serif;min-width: 200px !important;" @click="proceed('proceed')"  
						              >PROCEED</v-btn>
						        </div>
							</v-card-text>
						</v-card>
					</v-dialog> 
	            </div>	
			    <span v-bind:class="{'error-messagebox-login': isAddClassServerError}" id="server_side_error" ></span>
			    <v-row class="buttonbox">
					<v-btn class="blue-border-btn" @click="backButton" > Cancel </v-btn>
					<v-btn class="blue-btn" @click="submit" :disabled="!isFormValid"> Calculate</v-btn>
			    </v-row>
			</v-form>
		</div>
	</div>
</template>
<script>
	import moment from 'moment'
	import Datepicker from 'vuejs-datepicker'
	import { validationMixin } from 'vuelidate'
	import {required, email, minLength, sameAs, isAlphanumeric, alpha, numeric, maxLength} from "vuelidate/lib/validators";
	import axios from 'axios';
	import VueSpeedometer from "vue-speedometer"
	import { Auth } from 'aws-amplify';
	import { isEmpty } from 'lodash';


	export default {
	    components: {
	      Datepicker,
	      VueSpeedometer
	    },
	    mixins: [validationMixin],
	    data: () => ({
			protectometerLogo: process.env.VUE_APP_ROOT_ICONS_URL + 'protectometer.svg',
			informationIcon:   process.env.VUE_APP_ROOT_ICONS_URL + 'information.svg',
			syncIcon:          process.env.VUE_APP_ROOT_ICONS_URL + 'sync.svg',
            edumeterLogo: process.env.VUE_APP_ROOT_ICONS_URL + 'edumeter.svg',

			memberItems:[],
			member:[],
			dependent_items:[{'is_dependent':'Yes'}, {'is_dependent':'No'}],
			dependent:[],
			moreMemberItems:[],
			age:[],
			valid: true,
			submitted: false,
			activePicker: null,
			isAddClassServerError:false,
			menu: false,
			isFormValid:false,
			dob:[],
			disabledDates: {
			  from: new Date()
			},
			moreMemberItemCount:0,
			moreMemberItmes : [],
			mainMemberAge:'',
			mainMember:    '',
			mainMemberDob:'',
			moreMemberName:[''],
			moreMemberDependent:[],
			moreMemberDob:[],
			moreMemberAge:[],
			borderColor:'red',
			spikeValLife:150,
			protectometerMeterTextLife:'UNDERINSURED',
			spikeValHealth:150,
			protectometerMeterTextHealth:'HIGHLY UNDERINSURED',
			edumeter_score_dialog:false,
			memberType:[],
			member_type_items:[],
			moreMemberType:[],
			monthlyIncome:'',
			monthlyLivingExpense:'',
			monthlyExpenseTwardsDependentParents:'',
			totSumAssuredExistingLifeInsurance:'',
			totSumAssuredExistingHealthInsurance:'',
			loanOrCreditOutstanding:'',
			otherDebts:'',
			childrenExpense:[],
			currentInvestment:'',
			moreMemberChildrenExpenses:[],
			otherChildrenExpense:[],
			finalMoreMemberItems:[],
			lastModifiedDate:'18 Sep, 2023',

			currentLifeInsuranceCover:'',
			additionalLifeInsuranceCover:'',
			lifeInsuranceScore:1,
			lifeInsururanceScoreText:'',

			currentHealthInsuranceCover:'',
			additionalHealthInsuranceCover:'',
			healthInsuranceScore:1,
			healthInsururanceScoreText:'',
			healthInsururanceScoreText:'',
			allMemberList:[],
            loginMemberDob:'',
            loginMemberAge:'',
            getAllGeneralFamilyList:[],
            updatedMemberList:[],
            finalMemeberList:[],
            editAllMemberList:[],
            lastIncomeYear:'',
            disabledLastIncomeYearDates:{
			  to: new Date()
			},
			isMonthlyExpenseTwardsDependentParents:true,
			currentCorpusSavingsTwordsEducationExpense:'',
			current_monthly_saving_to_meet_educational_expenses:'',
			additional_monthly_saving_needed:'',
			message:'',
			edumeterScore:'',
			moreMemberItemCount:0
	    }),

	    created (){
	    	Auth.currentAuthenticatedUser({
				bypassCache: false
			})
		    .then(user => {
		    	this.allMemberList.push({'id':'0', 'name':user.attributes['custom:name']});
		    	this.loginMemberDob   = user.attributes['custom:birth'];
		    	this.loginMemberAge   = this.calculateAge(user.attributes['custom:birth']);

		        this.finalMemeberList = [];
				let cognito_idp       = atob(localStorage.getItem('cognito_idp'));
				let formdata          = new FormData();
				formdata.append("aws_cognito_id", cognito_idp);
			    axios.post(process.env.VUE_APP_ROOT_API + "get-goalsure-family-list", formdata).then((response) => {
			    	this.member_type_items = response.data.member_type_list;
			    	response.data.data.forEach(memberItem=>{
		    	        this.allMemberList.push({'id':memberItem.id, 'name':memberItem.name});
			    		let memberAge              = this.calculateAge(memberItem.dob);
			    		memberItem.age             = (memberAge == 0)?1:memberAge;
			    		memberItem.is_dependent    = '';
			    		memberItem.manual          = 'no';
			    		memberItem.monthly_expense = 0;
			    		this.finalMemeberList.push(memberItem);
			    		this.member.push(memberItem.name);
			    	});
		    	    this.finalMemeberList.push({'id':'0', 'name':user.attributes['custom:name'], 'is_dependent':'', 'monthly_expense':'', 'age':this.calculateAge(user.attributes['custom:birth']), 'member_type_id':'', 'dob':user.attributes['custom:birth']});
			        this.memberItems              = this.finalMemeberList;
				    this.moreMemberItmes.push(1);
				    this.moreMemberItemCount      = 1;
				    this.editAllMemberList        = this.allMemberList;
			    });
		    });

		    if(this.$route.params.id){
		      this.isFormValid  = true;
		      setTimeout(()=>{this.setIfMemberAllreadyHaveData(this.$route.params.id);}, 1000);
		      this.isFormValid  = true;
		    }
	    },
	    
	    methods: {
	    	changeTextFieldEvent() {
		        //this.isFormValid = this.$refs.form.validate()
		    },
	        calculateAge(dob){
	            let formated_dob = moment(String(dob)).format('DD MMM, yyyy')
	            let DOB          = new Date(formated_dob);  
	            let today        = new Date();
	            return today.getFullYear() - DOB.getFullYear();
	        },
	        calculateMoreMemberAge(dob, index){
				let ageIndex     = index ;	
				let age          = this.calculateAge(dob);
				this.moreMemberAge[ageIndex]  = (age == 0)?1:age;
	        },
	    	addRow(){
	    		this.moreMemberName.push('');
	    		this.moreMemberType.push('');
	    		this.moreMemberDob.push('');
	       	   	this.moreMemberAge.push('');
	            this.isFormValid = false;		
		        this.moreMemberItemCount++;
		        this.moreMemberItmes.push(this.moreMemberItemCount);
		    },
		    removeRow(){
		    	this.isFormValid = true;
		    	this.moreMemberType.pop();
				this.moreMemberName.pop();
				
				this.moreMemberDob.pop();
				this.moreMemberAge.pop();	
				this.moreMemberItmes.pop();
				this.moreMemberItemCount--;
				console.log(this.moreMemberItemCount)
		    },
		    setMemberDependency(i, dependency){
		        this.memberItems[i].is_dependent = dependency;
		    },
	    	backButton(){
	    		this.$router.push({ name: "ValueAddedServices", params: {}}).catch(()=>{}); 
	    	},

	    	submit(e){
	    		let memberDetails   = [];
	    		this.moreMemberType.forEach((item,index)=>{
	    			let expense = '';
	    			this.moreMemberChildrenExpenses.forEach((expenseItem,expenseIndex)=>{
                        if(expenseItem.itemID == index){
                           expense = expenseItem.expense;
                        } 
	    			});
	    			
	    			let memberRelation      = '';
	    			this.member_type_items.forEach(memberTypeItem=>{
	    				if(memberTypeItem.id == item){
                            memberRelation  = memberTypeItem.type;
	    				}
	    			});
	    			memberDetails.push({'name':this.moreMemberName[index],  'dob':this.moreMemberDob[index], 'member_type_id':item, 'age':this.moreMemberAge[index], 'relation':memberRelation, 'monthly_expense':expense});
	    		});


				let cognito_idp  = atob(localStorage.getItem('cognito_idp'));
				let formdata     = new FormData();
				formdata.append("aws_cognito_id", cognito_idp);
				formdata.append("mainMemberId", this.mainMember);
				formdata.append("mainMemberDob", this.mainMemberDob);
				formdata.append("mainMemberAge", this.mainMemberAge);
				formdata.append("monthlyIncome", this.monthlyIncome);
				formdata.append("memberDetails", JSON.stringify(memberDetails));
				formdata.append("currentCorpusSavingsTwordsEducationExpense", this.currentCorpusSavingsTwordsEducationExpense);

			    axios.post(process.env.VUE_APP_ROOT_API  + "post-edumeter", formdata).then((response) => {	
					this.current_monthly_saving_to_meet_educational_expenses=response.data.data.current_monthly_saving_to_meet_educational_expenses;
					this.additional_monthly_saving_needed=response.data.data.additional_monthly_saving_needed;
					this.message=response.data.data.message;
					this.edumeterScore=response.data.data.edumeterScore;
                    this.edumeter_score_dialog   = true;
			    });		    		
	    	},

	    	proceed(e){
		        if(e == 'investometer'){
		          this.$router.push({ name: "Investometer", params: {}}).catch(()=>{});       
		        }
		        else{
		          this.$router.go(0);       
		        }
		    },

		    setExpense(i, val, type){
		    	if(type =='fromList'){
		    	    this.memberItems[i].monthly_expense = val;
		    	}
		    	else{
                    this.moreMemberChildrenExpenses.push({'itemID':i, expense:val});
		    	}
		    },

		    syncMemberData(){
                let cognito_idp  = atob(localStorage.getItem('cognito_idp'));
				let formdata     = new FormData();
				formdata.append("aws_cognito_id", cognito_idp);
				formdata.append("mainMemberId", this.mainMember);
			    axios.post(process.env.VUE_APP_ROOT_API + "sync-goalsure-data", formdata).then((response) => {	
                    this.totSumAssuredExistingLifeInsurance   = response.data.data.sum_assured_in_life_insurance;
                    this.totSumAssuredExistingHealthInsurance = response.data.data.sum_assured_in_health_insurance;
                    this.currentInvestment                    = response.data.data.total_investment;
                    this.loanOrCreditOutstanding              = response.data.data.loan_outstanding;
			    });
		    },

	        setMainMemberData(id){
	        	this.isFormValid = true
	        	this.mainMember = id;
	        	let newMemberList = []
		    	this.memberItems.forEach(memberItem=>{
		    		if(id == memberItem.id){
                   	   this.mainMemberDob = memberItem.dob;
	    	           this.mainMemberAge = memberItem.age;
                    }
                    if(this.mainMember != memberItem.id){
                        if(id == 0){
                        	if(memberItem.member_type_id==1 || memberItem.member_type_id==2 || memberItem.member_type_id==3 || memberItem.member_type_id==4 || memberItem.member_type_id==5){
                   	            newMemberList.push({'id':memberItem.id, 'name':memberItem.name});  
                        	}
                        }
                        else{
                   	        newMemberList.push({'id':memberItem.id, 'name':memberItem.name});
                        }	
                    }
	    		});
	    		this.updatedMemberList.push(newMemberList);
	    		this.isFormValid = true;
		    },

		    updateMoreMemberList(selectedMemberDetail, i){
		    	this.memberItems.forEach(memberItem=>{
                    if(selectedMemberDetail == memberItem.name){
						this.moreMemberDob[i]  = memberItem.dob;
						this.moreMemberAge[i]  = memberItem.age;
						if(this.mainMember == 0){
						   this.moreMemberType[i] = memberItem.member_type_id;
						}
                    }
	    		});
		    	let newMemberList = [];
	    		let nextDropdownItemsIndex = i+1;
		    	this.updatedMemberList[i].forEach(memberItem=>{
                    if(selectedMemberDetail != memberItem.name){
                   	  newMemberList.push({'id':memberItem.id, 'name':memberItem.name});
                    }
	    		});
	    		this.updatedMemberList[nextDropdownItemsIndex] = newMemberList;
		    },

		    checkTerm(){
		        this.$router.push({ name: "FinStat", params: {}}).catch(()=>{});       
		    },

		    setIfMemberAllreadyHaveData(memberId){
		    	if(memberId == '0'){
			    	    this.mainMember = memberId.toString();
			    	} 
			    	else{
			            this.mainMember = parseInt(memberId);
			    	} 
		    	this.mainMember = memberId
		    	this.moreMemberItmes               = [];
                this.moreMemberName                = [];
                this.updatedMemberList             = [];
                this.moreMemberType                = [];
                this.otherChildrenExpense          = [];
                this.moreMemberChildrenExpenses    = [];
		    	let allreadySelectedMemberItemList = [];
                let cognito_idp                    = atob(localStorage.getItem('cognito_idp'));
				let formdata                       = new FormData();
				formdata.append("aws_cognito_id", cognito_idp);
				formdata.append("mainMemberId", memberId);
			    axios.post(process.env.VUE_APP_ROOT_API + "get-edumeter-detail", formdata).then((response) => {	
			    	
			    	if(response.data.data.mainMemberId == '0'){
			    	    this.mainMember = response.data.data.mainMemberId.toString();
			    	} 
			    	else{
			            this.mainMember = parseInt(response.data.data.mainMemberId);
			    	} 

			    	this.currentCorpusSavingsTwordsEducationExpense = response.data.data.currentCorpusSavingsTwordsEducationExpense;
			    	this.monthlyIncome = response.data.data.monthlyIncome;

			    	this.moreMemberItemCount   = response.data.data.memberDetails.length;
			    	let filterMember           = '';
			    	let newMemberList          = this.editAllMemberList;
			    	this.finalMemeberList.forEach((memberItem, itemIndex)=>{
			    		if(memberItem.id      == response.data.data.mainMemberId){
			    			this.mainMemberDob = memberItem.dob;
			    			this.mainMemberAge = memberItem.age;
			    			filterMember       = memberItem.name;
			    		}
			    	});
			    	response.data.data.memberDetails.forEach((item, index)=>{
			    		newMemberList = this.filterList(newMemberList, filterMember);
						this.updatedMemberList.push(newMemberList);
						filterMember  = item.name.name;
						this.moreMemberItmes.push(1);
						this.moreMemberName.push(item.name); 
						this.moreMemberType.push(item.member_type_id);
						this.moreMemberAge.push(item.age);
						this.moreMemberDob.push(item.dob);
					    this.otherChildrenExpense.push(item.monthly_expense);
					    this.moreMemberChildrenExpenses.push({'itemID':index, expense:item.monthly_expense});
			    	});	

			    	console.log(this.moreMemberAge)
			    });
		    },

		    filterList(list, item){
		    	let array = [];
		    	list.forEach((detail, i)=>{
	    			if(detail.name != item){
	    				array.push(detail);
	    			}
	    		});
	    		return array;
		    },

		    lastGetIncomeYear(e){
                this.lastIncomeYear = e;
		    },

		    formatPrice(value) {
		        var formatter = new Intl.NumberFormat('en-US', {});
		        return formatter.format(value);
		    },
	    },
	};
</script>
<style scoped>
	.more_btn_class{
	  	background-color:#F19700 !important; 
	  	border-color:#F19700 !important; 
	  	min-width: 77px !important; 
	  	float:right; 
	  	margin-right: -100px !important; 
	  	height:30px !important;
	}

    .remove_btn_class{
	  	background-color:#f44336 !important; 
	  	border-color:#f44336 !important; 
	  	min-width: 77px !important; 
	  	float:right; 
	  	margin-right: -4px !important; 
	  	height:30px !important;
    }

    .add-new-memberbox .edit-profilebox-detail .row {
        max-width: 100%;
    }

    .income_container {
	    max-width: 1140px;
	    width: 100%;
	    margin: 0 auto;
	}

	.income_container .info_box {
	    display: flex;
	    justify-content: space-between;
	    align-items: center;
	}

	.income_container .income_title h3 {
	    font-size: 16px;
	    color: #1A407D;
	    max-width: 220px;
	    width: 100%;
	}

	.income_container .income_date {
	    min-width: 110px;
	}

	.income_container .income_date p {
	    color: #7D7D7D;
	}

	.income_container .your_income_section.row {
	    padding-top: 20px;
	    border-top: 1px solid #E5E5E5;
	    margin-top: 20px;
	}

	.income_container .sync_detils {
	    text-align: end;
	    padding-bottom: 40px;
	    position: relative;

	}

	.income_container .sync_detils span {
	    color: #1A407D;
	    border-bottom: 1px solid #1A407D;
	   
	}

	.income_container .your_ins_price {
	    display: flex;
	    justify-content: space-between;
	    padding-top: 20px;
	    align-items: center;
	}

	.income_container .your_ins_price p {
	    font-size: 15px;
	    color: #333333;
	    max-width: 230px;
	    width: 100%;
	    position: relative;
	}

	.your_ins_price.expenses p::after {
	    content: '';
	    height: 20px;
	    width: 20px;
	    background-size: contain;
	    background-repeat: no-repeat;
	    display: inline-block;
	    /* transform: translate(-50%,-50%); */
	    margin-left: 20px;
	    position: absolute;
	    top: 3px;
	}

	.your_ins_price.expenses span {
	    color: #7B7B7B;
	    font-size: 12px;
	}

	.col-md-6.investments {
	    border-left: 1px solid #E5E5E5;
	}

	.income_container input[type="text"] {
	    width: 111px;
	    height: 49px;
	    border: 1px solid #DDDDDD;
	    border-radius: 6px;
	    text-align: center;

	}

	.income_container .col-md-6.expenses {
	    padding-right: 30px;
	}

	.income_container .col-md-6 {
	    padding-right: 30px;
	    padding-left: 30px;
	}

	.income_container .proceed_btn button {
	    border: none;
	    padding: 13px 50px;
	    font-size: 15px;
	}

	.income_container .proceed_btn .btn1 {
	    border: 1px solid #051D42;
	    border-radius: 6px;
	    background-color: transparent;
	}

	.income_container .proceed_btn .btn_proceed {
	    background-color: #051D42;
	    color: white;
	    margin-left: 20px;
	}

	.proceed_btn .btn_cancel:hover {
	    background-color: #051D42;
	    color: white;
	    transition: .3s ease all;
	}

	.proceed_btn .btn_proceed:hover {
	    background-color: transparent;
	    color: black;
	    transition: .3s ease all;
	}

	.income_container .sync_detils span::after{
	    content: '';
	    height: 20px;
	    width: 20px;
	    background-size: contain;
	    background-repeat: no-repeat;
	    display: inline-block;
	    margin-left: 5px;
	    position: absolute;
	    top: 3px;    
	}

	section.your_income_section {
	    display: flex;
	    justify-content:center;
	}
	.riskMeter_btn {
    	text-align: center;
	}
	.add-new-memberbox .row.buttonbox {
	    margin-bottom: 25px !important;
	    margin-top: 50px !important;
	}
	.text_icon {
	    display: flex;
	    justify-content: space-between;
	}
	.icon_tick{
	    margin-left: 8px;
	    margin-top: 2px;
	}
	.info_box.date-and-info {
	    font-size: 14px;
	}

	.info_box.date-and-info h3 {
	    font-size: 14px !important;
	    color: #818181 !important;
	    font-weight: 500;
	}

	.info_box.date-and-info p {
	    margin: 0;
	    color: #818181 !important;
	    font-weight: 400;
	    margin-right: 5px;
	}
	span.percent-num {
	    font-size: 20px !important;
	    color: #1A407D !important;
	}	
	.terms-box {
	    background: #F3F3F3;
	    padding: 15px 20px;
	    margin-top: 20px;
	}
	.sync_detils.main-sync-heading {
	    display: flex;
	    align-items: center;
	    justify-content: flex-end;
	}

	.sync_detils.main-sync-heading span {
	    border: none !important;
	    margin-right: 5px;
	}

	.member_relation_box.col.member_dob.col-md-2.col {
	    position: relative;
	}
	.dob-box1 ::before {
	    content: "";
	    position: absolute;
	    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAAZVJREFUOBGtlO9xgkAQxeVPAXRgHP2uqQBSQUpIOhEriSkhFUQrCPmOoyXQAJLfIxzDBSeeyM4cu/d297G3tzCZdORwOKSs6ng8Jh34X1OxylFuNzDUBmeEWp7P56n26CVYJfuaKLaJmZITY3/PZrPCY7PC+Qkg8jGk8H3/KYR0C5tIN1VVJZ7nxeh39AnsqhD7QOwLeo/ekbCG822i/uR5LkD23T0WlzjrHotUwhG2qB0rY7lKpqMTfOomeGIHKDjKLWRdDsumHSuAyFQcASRWxJ2bmliNXywWoxCrxxQZm4rr+nR5GNV8Pt8whgm3G9O/PXOpC3Hy1UQ8fGM0eo1OZUOaoNJGC3LyKVBiVcx+U6M8qHQHaa0bzMln8jW77Ry34B2GmWOrFXqJlnjV02afNnsnn2IlFvEvNNJTVZlPegxK0wrr8nR8yG8et0sF/W2F00hdGMUet1UxXqeRujCKPWLzE8r42h573gEA7dTPbBnyn/jg234G+MIuBnC1KfBEIhVnGATBa1mWW5Gz2qChhkjF+QMBIlHMGk2p1wAAAABJRU5ErkJggg==);
	    width: 25px;
	    height: 25px;
	    right: 2px !important;
	    top: 10px !important;
	    pointer-events: none;
	}


</style>